"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getRentAmountContent = exports.RENT_AMOUNT = void 0;
exports.RENT_AMOUNT = {
    FLEX_ANYWHERE: {
        HEADER: 'Tell us about your lease',
        BODY_CO: 'We use this info to verify who receives your rent and estimate your payments. Include everything your property charges so we can accurately calculate your payments.',
        BODY: 'We’ll use this info to estimate your payments and verify who is receiving your rent.\n\nMake sure to include any fees that appear on your monthly rent bill, like pet fees or utilities.',
        INPUT_LABEL_CO: 'Estimated rent bill',
        INPUT_LABEL: 'Monthly rent'
    },
    FLEX_ANYWHERE_FLYWHEEL: {
        HEADER: 'Tell us about your property',
        BODY: 'We use this info to verify who receives your rent and estimate your payments.',
        INPUT_LABEL: 'Estimated rent bill'
    },
    CLASSIC: {
        HEADER: 'How much is your rent bill?',
        BODY_CO: 'Include everything your property charges so we can accurately calculate your payments.',
        BODY: 'Include any fees that appear on your monthly rent bill, like pet fees or utilities.',
        INPUT_LABEL_CO: 'Estimated rent bill',
        INPUT_LABEL: 'Monthly rent'
    },
    AMOUNT_CHANGES_MODAL: {
        HEADER: 'What if the amount changes each month?',
        BODY_ONE: 'We understand that sometimes your bill amount might be a little higher or lower. As long as it’s close, don’t worry!',
        BODY_TWO: 'If there is a big difference between your reported rent and the attempted payment, we’ll follow up for more information.',
        CTA: 'Close'
    },
    AMOUNT_CHANGES: 'What if the amount changes each month?',
    HELPER_TEXT: 'If your bill isn’t the same every month because it includes variable fees (like utilities), your best estimate is fine.',
    CTA: 'Continue',
    CONFIRM_HEADER: 'Confirm your rent amount',
    PROPERTY_NAME_INPUT_LABEL: 'Property name',
    PROPERTY_NAME_HELPER_TEXT: 'If you don’t know, provide your management company’s name.',
    PORTAL_INPUT_LABEL: 'Rent payment portal or property website',
    PORTAL_INPUT_PLACEHOLDER: 'Example: www.clickpay.com',
    PORTAL_INPUT_HELPER_TEXT: 'Enter or copy link for where you go to pay rent'
};
var getRentAmountContent = function (_a) {
    var isFlexAnywhere = _a.isFlexAnywhere, isFAFlywheelEnabled = _a.isFAFlywheelEnabled;
    var contentType;
    if (isFlexAnywhere) {
        contentType = isFAFlywheelEnabled ? 'FLEX_ANYWHERE_FLYWHEEL' : 'FLEX_ANYWHERE';
    }
    else {
        contentType = 'CLASSIC';
    }
    var content = __assign(__assign({}, exports.RENT_AMOUNT), exports.RENT_AMOUNT[contentType]);
    return content;
};
exports.getRentAmountContent = getRentAmountContent;
